/*
 * Sitewide progressive enhancement for native form validation (WCAG 3.3.1).
 * Native validation only shows a browser tooltip with no persistent, visible,
 * screen-reader-linked error. This adds aria-invalid + an aria-describedby
 * error message alongside (not instead of) the browser's own validation.
 */
(function () {
  function getErrorId(field) {
    return field.id ? field.id + '-error' : null;
  }

  function showError(field) {
    var errorId = getErrorId(field);
    if (!errorId) return;

    var errorEl = document.getElementById(errorId);
    if (!errorEl) {
      errorEl = document.createElement('span');
      errorEl.id = errorId;
      errorEl.className = 'field-error-message';
      errorEl.setAttribute('role', 'alert');
      field.insertAdjacentElement('afterend', errorEl);
    }

    errorEl.textContent = field.validationMessage;
    field.setAttribute('aria-invalid', 'true');

    var describedBy = field.getAttribute('aria-describedby');
    if (!describedBy || (' ' + describedBy + ' ').indexOf(' ' + errorId + ' ') === -1) {
      field.setAttribute('aria-describedby', describedBy ? describedBy + ' ' + errorId : errorId);
    }
  }

  function clearError(field) {
    field.setAttribute('aria-invalid', 'false');
    var errorId = getErrorId(field);
    if (!errorId) return;
    var errorEl = document.getElementById(errorId);
    if (errorEl) errorEl.textContent = '';
  }

  document.addEventListener(
    'invalid',
    function (event) {
      var field = event.target;
      if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement || field instanceof HTMLSelectElement)) return;
      showError(field);
    },
    true
  );

  document.addEventListener('input', function (event) {
    var field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;
    if (field.getAttribute('aria-invalid') === 'true' && field.checkValidity()) {
      clearError(field);
    }
  });

  document.addEventListener('change', function (event) {
    var field = event.target;
    if (!(field instanceof HTMLSelectElement)) return;
    if (field.getAttribute('aria-invalid') === 'true' && field.checkValidity()) {
      clearError(field);
    }
  });
})();
